import { deepCopy, safeReference, getNumDaysFromDateRange, timeDiff } from "../../../app/util";
import { useDataSummary } from "../../Tile/kpiService";
import dataService from "../../../services/data.service";
import moment from "moment";
import { APP_CACHE } from "../../../app/config";
export function getPricingDataFormatted({ primary_stay_range, room_settings }, isRoomType = false, rateRecomended = []) {
    let permissions = APP_CACHE.permissions || {};
    const numDays = getNumDaysFromDateRange(primary_stay_range);
    let baseRoom = "";
    room_settings.map(room => {
        if (room.is_base === true) {
            baseRoom = room.room_code;
        }
    })

    if (rateRecomended.length === 0 &&
        dataService.getSeriesById("OSRRateRecommend")
        && dataService.getSeriesById("OSRRateRecommend").data) {
        rateRecomended = deepCopy(dataService.getSeriesById("OSRRateRecommend").data.data);
    }


    let pricingData = [];
    let currDate = moment(primary_stay_range.date_from);

    for (let index = 0; index < numDays; index++) {
        let dataPoint = {
            stay_date: currDate.format("YYYY-MM-DD")
        };
        if (!isRoomType) {
            let found = false;
            rateRecomended.map(rateData => {

                if (rateData.stay_date === currDate.format("YYYY-MM-DD")) {
                    if (rateData.is_base === true || rateData.room_type === baseRoom) {
                        // if(rateData.is_rate_overridden) debugger;
                        dataPoint.RecSellRate = rateData.algo_generated_recommended_rate;
                        dataPoint.SellRate = rateData.current_sell_rate;
                        //Added for pricing enhancement LRV-1360
                        dataPoint.auto_rate_push_enabled = rateData.auto_rate_push_enabled;
                        dataPoint.is_rate_overridden = rateData.is_rate_overridden;
                        dataPoint.overridden_at = rateData.overridden_at;
                        dataPoint.overridden_by = rateData.overridden_by;
                        if (rateData.pushed === true) {
                            dataPoint.SellRate = rateData.resolved_sell_rate;
                        }
                        dataPoint.Explainer = rateData.explainer?.txt_msg.length ? rateData.explainer.html_msg : null;
                        found = true;
                    }
                }
            })
            if (!found) {
                dataPoint.RecSellRate = 0;
                dataPoint.SellRate = 0
            }
        } else {
            let differentialKey = 'algo_generated_differential';
            if (permissions && permissions.pricing_model === 1) differentialKey = 'seasonal_differential';
            rateRecomended.map(rateData => {

                if (rateData.stay_date === currDate.format("YYYY-MM-DD") && rateData.room_type) {

                    dataPoint[rateData.room_type] = {
                        RecSellRate: rateData.algo_generated_recommended_rate,
                        SellRate: rateData.current_sell_rate,
                        lodgiq_differential: rateData[differentialKey],
                        hierarchy_order: rateData.hierarchy_order,
                        rooms_sold: rateData.rooms_sold,

                        //This added for pricing enhancement LRV-1360
                        auto_rate_push_enabled: rateData.auto_rate_push_enabled,
                        is_rate_overridden: rateData.is_rate_overridden,
                        overridden_at: rateData.overridden_at,
                        overridden_by: rateData.overridden_by,

                        // Added current_diff to show on hotel pricing cart
                        current_diff: 0
                    }
                    if (rateData.pushed === true) {
                        dataPoint[rateData.room_type].SellRate = rateData.resolved_sell_rate
                    }
                    let baseRoomRateData = rateRecomended.find(r => r.room_type === baseRoom && r.stay_date === rateData.stay_date);
                    let roomSellRate = rateData.pushed === true ? rateData.resolved_sell_rate : rateData.current_sell_rate;
                    let baseRoomSellRate = baseRoomRateData.pushed === true ? baseRoomRateData.resolved_sell_rate : baseRoomRateData.current_sell_rate;
                    roomSellRate = roomSellRate | 0;
                    baseRoomSellRate = baseRoomSellRate | 0;
                    dataPoint[rateData.room_type].current_diff = roomSellRate - baseRoomSellRate;
                }
            })
        }

        pricingData.push(dataPoint);
        currDate.add(1, 'days');
    }
    return pricingData;
}

export function getPricingDataInt(dataPoint, key) {
    let pricingDataInt = {};
    if (key.subcol_id === "pricing_SellRate") {
        pricingDataInt.SellRate = dataPoint.SellRate
        if (pricingDataInt.SellRate === null) {
            pricingDataInt.SellRate = 0
        }
    }
    if (key.subcol_id === "pricing_RecSellRate") {
        pricingDataInt.RecSellRate = dataPoint.RecSellRate;
        if (pricingDataInt.RecSellRate === null) {
            pricingDataInt.RecSellRate = ""
        }
    }
    if (key.subcol_id === "pricing_ratediff") {
        // dataPoint.RecSellRate = dataPoint.RecSellRate | 0;
        // dataPoint.RecSellRate = dataPoint.SellRate | 0;
        let rateDiff;
        if (dataPoint.RecSellRate === null || dataPoint.RecSellRate === "") {
            rateDiff = "";
        } else {
            rateDiff = dataPoint.RecSellRate - dataPoint.SellRate;
        }
        pricingDataInt.ratediff = rateDiff;

    }
    return pricingDataInt;
}
export function addPastDates(data, as_of_date) {
    let osrData = [];
    if (dataService.getSeriesById("OSR").data) {
        osrData = dataService.getSeriesById("OSR").data.data;
        data = data.map((item, dataIndex) => {

            if (timeDiff(item.stay_date, as_of_date, 'days') > 0) {
                let osrDp = osrData[dataIndex];
                item.SellRate = osrDp.HotelTotal.primary.SellRate;
            }
            return item;

        })
    }
    return data;
}
export function getRTDataFormatted(otbData, room_settings) { // LRV-1124
    let rtData = (dataService.getSeriesById("GetRoomType").data) ? dataService.getSeriesById("GetRoomType").data.data : [];
    console.log("rtData", rtData);
    if (rtData.length === 0) {
        const dataTypesArray = ["primary", "pickup", "sdly", "sdly_actual"]
        const measures = ["ADR", "Capacity", "Occ", "RevPAR", "Revenue", "Rooms", "SellRate"]
        for (let i = 0; i < otbData.length; i++) {
            const dataPoint = {
                HotelTotal: {},

            }
            room_settings.forEach(room => {
                const segName = "Segment_" + room.room_code;
                dataPoint[segName] = {};
            })
            for (let j = 0; j < dataTypesArray.length; j++) {
                const dType = dataTypesArray[j];
                Object.keys(dataPoint).forEach(key => {
                    dataPoint[key][dType] = {};
                    for (let index = 0; index < measures.length; index++) {
                        const measure = measures[index];
                        dataPoint[key][dType][measure] = 0;

                    }
                })


            }
            let date = moment(otbData[i].stay_date).format();
            let sdly_date = moment(otbData[i].stay_date).subtract(364, 'days').format();
            dataPoint["index"] = { date: date, sdly_date: sdly_date, timestamp: moment(otbData[i].stay_date).unix() };
            rtData.push(dataPoint);

        }

    }

    return rtData;

}
